import * as React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';



//components used to displaye and alter the quantity of something
// used on dishes and extras
function QtyButton({getQty, setQty}) {

  function handleIncrease() {
    setQty(getQty()+1);
  }

  function handleDecrease() {
    if (getQty() > 0) {
      setQty(getQty()-1);
    }
  }

  return (
    <Box sx={{display: 'flex', flexDirection:'column', alignItems: 'center', justifyContent: "center",
    '@media (max-width:500px)': {
      ml: 1
    }}}>
      <Box sx={{display: 'flex', flexDirection: 'row'}}>

        <Button sx={{color: "black", border: "none", width: '10%', fontSize: "2rem"}} onClick={handleDecrease}>-</Button>

        <h3>{getQty()}</h3>

        <Button sx={{color: "black", border: "none", fontSize: "1rem", fontWeight: "bold"}} onClick={handleIncrease}>+</Button>
      </Box>
    </Box>
    
  )
}

export default QtyButton;